<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-spacer> </v-spacer>
      <v-btn
        small
        :to="{name: 'Plans'}"
        class="teal white--text mr-md-1"
        >خرید اشتراک جدید</v-btn
      >
    </v-card-title>
    <v-card-text>
      <m-datatable :headers="headers" :apiUrl="url" :filters.sync="filters" ref="datatable">
        <template #item.renewal="{ item }">
          <v-btn color="success" @click="renewal(item)">تمدید اشتراک</v-btn>
        </template>
      </m-datatable>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SubscriptionsList",
  data() {
    return {
      filters: {},
    };
  },
  computed: {
    url() {
      return "subscriptions/list";
    },
    title() {
      return "اشتراک ها";
    },
    headers() {
      let headers = [
        {
          text: "پلن",
          value: "plan.name",
        },
        {
          text: "تاریخ انقضا",
          value: "expired_at",
        },
        {
          text: "شرکت ها",
          value: "companies",
        },
        {
          text: "تمدید",
          value: "renewal",
        },
      ];

      return headers;
    },
  },
  methods: {
    renewal(){

    }
  },
};
</script>

<style scoped lang="scss"></style>
